import React, { useState } from 'react';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';
import { OpenPositionRow } from '../OpenPositionRow';
import { Body3 } from '../../../../../../atomic/text/Text';
import { colors } from '../../../../../../../colorVars';
import { headerList } from '../headerList';
import { OpenPositionsHeader } from '../OpenPositionsHeader';
import ExpandButton from '../../../../../../atomic/buttons/expandButton/ExpandButton';
export const OpenAllTable = observer(() => {
  const { tradePlanStore } = useWebsocketStore();
  const tuPositionList = tradePlanStore.tuPositionList;
  const tradierPositionList = tradePlanStore.tradierPositionList;
  const [tuExpanded, setTuExpanded] = useState(true);
  const [tradierExpanded, setTradierExpanded] = useState(false);
  return (
    <>
      <thead></thead>
      <tbody>
        <tr onClick={() => setTuExpanded((prev) => !prev)}>
          <td
            colSpan={headerList.length + 1}
            style={{ border: '1px solid rgb(88, 88, 88)', minWidth: '600px' }}
          >
            <ExpandButton
              stroke={2}
              size={10}
              color={colors.lightGrey}
              direction="bottom"
              expanded={tuExpanded}
              handleClick={() => {}}
              display="inline"
              margin="0 5px 0 5px"
            />
            <Body3 fontWeight={700} color={colors.lightGrey}>
              Trade Unafraid
            </Body3>
          </td>
        </tr>
      </tbody>
      {tuExpanded ? (
        <>
          <OpenPositionsHeader />
          <tbody>
            {tuPositionList.map((positionId, index) => (
              <OpenPositionRow
                key={positionId}
                positionId={positionId}
                department="tradeUnafraid"
                odd={index % 2}
              />
            ))}
          </tbody>
        </>
      ) : null}
      <tbody>
        <tr onClick={() => setTradierExpanded((prev) => !prev)}>
          <td
            colSpan={headerList.length + 1}
            style={{ border: '1px solid rgb(88, 88, 88)', minWidth: '600px' }}
          >
            <ExpandButton
              stroke={2}
              size={10}
              color={colors.lightGrey}
              direction="bottom"
              expanded={tradierExpanded}
              handleClick={() => {}}
              display="inline"
              margin="0 5px 0 5px"
            />
            <Body3 fontWeight={700} color={colors.lightGrey}>
              Tradier
            </Body3>
          </td>
        </tr>
      </tbody>
      {tradierExpanded ? (
        <>
          <OpenPositionsHeader />
          <tbody>
            {tradierPositionList.map((positionId, index) => (
              <OpenPositionRow
                key={positionId}
                positionId={positionId}
                department="tradier"
                odd={index % 2}
              />
            ))}
          </tbody>
        </>
      ) : null}
    </>
  );
});
